/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import UpcomingProgramsV2 from './../../../../../components/UI/UpcomingProgramsV2';
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
import UpcomingEventSt from '@moms/styleData/UpcomingEventSt';
/* Styles */
import EsteemedSt from '@moms/styleData/EsteemedSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const MainHeading = ({ region, lang, sectionContent }) => {
  const title = sectionContent[0]?.titleText;
  const subtext = sectionContent[0]?.additionalTextLine;
  return (
    <Box
      as="h1"
      display={{ base: 'block', md: 'flex' }}
      textAlign={'center'}
      justifyContent={'center'}
      mb={{ base: '1.5rem', md: '2rem' }}
      gap=".8rem"
      {...EsteemedSt?.[lang]?.title}
    >
      <Text
        as="span"
        color={'#EC2224'}
        fontStyle={lang === 'en' ? 'italic' : ''}
      >
        {title}
      </Text> {``}
      <Text
        as="span"
        color={'#FFFFFF'}
        fontStyle={lang === 'en' ? 'normal' : ''}
        fontWeight={400}
      >
        {subtext}
      </Text>
    </Box>
  );
};

const UpcomingProgram = ({ region, lang, sectionContent }) => {
  return (
    <>
      <MainHeading
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />
      <Box maxW={'1330px'} fontSize={'18px'} m="0 auto" p={{base:'0 20px', md:'0'}}>
        <StructuredTextParser
          color="#FFFFFFB2"
          str={render(sectionContent[1].body.value)}
          textAlign={{base:'left', md:'center'}}
          {...UpcomingEventSt[lang].descText}
        />
      </Box>
      <UpcomingProgramsV2
        sectionContent={sectionContent[2]}
        region={region}
        language={lang}
        pageName={'mom'}
      />
      <style>
        {`
            .css-onkibi { color: #ffffff;}
        `}
      </style>
    </>
  );
};

export default UpcomingProgram;
